// extracted by mini-css-extract-plugin
export default {"saleContainer":"Sale_saleContainer__tEd+p","saleContainerTitle":"Sale_saleContainerTitle__M87z8","saleContainerPara":"Sale_saleContainerPara__1SszU"};